import { Link } from 'react-router-dom';
import { useLocale } from '@/i18n/locale-context';
import { Button, Input } from '@/components/ui';

/**
 * PRD §16's signup block — **UI only** this phase, as the task list says; Phase 13 adds
 * the double opt-in round trip.
 *
 * The submit button navigates to the newsletter page rather than pretending to subscribe.
 * A form that silently does nothing is the worst of the three options available here, and
 * a disabled button with no explanation is the second worst.
 */
export function NewsletterBlock() {
  const { t, path } = useLocale();

  return (
    <div className="rounded-xl border border-line bg-soft p-6">
      <h3 className="mb-2 text-xl font-extrabold text-ink">{t('newsletter.title')}</h3>
      <p className="mb-4 text-base text-body">{t('newsletter.body')}</p>
      <form
        className="flex flex-col gap-3"
        action={path('newsletter')}
        method="get"
        // No handler: Phase 13 owns submission. Until then this is a link with a field.
      >
        <Input
          label={t('newsletter.placeholder')}
          labelHidden
          type="email"
          name="email"
          autoComplete="email"
          placeholder={t('newsletter.placeholder')}
        />
        <Button type="submit">{t('newsletter.submit')}</Button>
      </form>
      <p className="mt-3 text-xs text-muted">
        <Link to={path('privacy')} className="underline-offset-2 hover:underline">
          {t('footer.privacy')}
        </Link>
      </p>
    </div>
  );
}
